export type ContactFormFieldConfig = {
    name: string;
    type?: 'text' | 'email' | 'password' | 'tel' | 'url' | 'number' | 'search';
    label?: string;
    placeholder?: string;
    required?: boolean;
    as?: 'input' | 'textarea';
    errorRequired?: string;
    errorInvalid?: string;
    errorMinLength?: string;
    minLength?: number;
};

export type ContactSocialItem = {
    id: 'email' | 'linkedin' | 'twitter';
    label: string;
    href: string;
};

export type ContactMock = {
    contactInfo: {
        email: string;
        location: string;
    };
    socials: ContactSocialItem[];
    form: {
        title: string;
        subtitle: string;
        contactSideTitle: string;
        formSideTitle: string;
        fields: ContactFormFieldConfig[];
        honeypotName: string;
        submitLabel: string;
        sendingLabel: string;
        successMessage: string;
        socialsTitle: string;
    };
};

export const contactMock: ContactMock = {
    contactInfo: {
        email: 'teriv168@gmail.com',
        location: 'Ukraine',
    },
    socials: [
        { id: 'email', label: 'Email', href: 'mailto:teriv168@gmail.com' },
        { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/mykola-teriv/' },
    ],
    form: {
        title: "Let's Connect",
        subtitle: "Have a project in mind? Let's build something amazing together.",
        contactSideTitle: 'Contact Information',
        formSideTitle: 'Send a Message',
        fields: [
            {
                name: 'name',
                type: 'text',
                placeholder: 'Your Name',
                required: true,
                as: 'input',
                errorRequired: 'Please enter your name',
            },
            {
                name: 'email',
                type: 'email',
                placeholder: 'Your Email',
                required: true,
                as: 'input',
                errorRequired: 'Please enter your email address',
                errorInvalid: 'Please enter a valid email address',
            },
            {
                name: 'message',
                placeholder: 'Your Message',
                required: true,
                as: 'textarea',
                minLength: 10,
                errorRequired: 'Please enter your message',
                errorMinLength: 'Message must be at least 10 characters long',
            },
        ],
        honeypotName: 'website',
        submitLabel: 'Send Message',
        sendingLabel: 'Sending…',
        successMessage: "Thank you for your message. I'll get back to you soon",
        socialsTitle: 'Get in touch with me',
    },
};
